import {
  WorkspaceFormDialog,
  type WorkspaceFormValues,
} from "@/action-dialog/dialogs/WorkspaceFormDialog";
import type { Workspace } from "@cohesive/api-client";
import { createCallable } from "react-call";
import { useMutationFlow, type MutationFn } from "react-call/mutation-flow";

const UNMOUNTING_DELAY_MS = 200;

export type EditWorkspaceCallableProps = {
  workspace: Workspace;
  mutationFn?: MutationFn<boolean, WorkspaceFormValues>;
};

export const EditWorkspaceCallable = createCallable<
  EditWorkspaceCallableProps,
  boolean
>(({ call, workspace, mutationFn }) => {
  const submit = useMutationFlow(call, mutationFn);
  const pending = submit.pending;

  return (
    <WorkspaceFormDialog
      open
      title="Edit workspace"
      description="Update this workspace's name, icon, and description."
      isPending={pending}
      initialValues={{
        name: workspace.name ?? "",
        icon: workspace.metadata?.icon ?? null,
        description:
          workspace.description ?? workspace.metadata?.description ?? "",
      }}
      onClose={() => {
        if (!pending) {
          call.end(false);
        }
      }}
      onSubmit={(values) => submit(values).orEnd(true)}
    />
  );
}, UNMOUNTING_DELAY_MS);

EditWorkspaceCallable.displayName = "EditWorkspaceCallable";
